/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Adv_1Inputs */

const en_pc_cmp_adv_1 = /** @type {(inputs: Pc_Cmp_Adv_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saves US$180 to US$300 per person per year compared with an Acrobat subscription.`)
};

const zh_pc_cmp_adv_1 = /** @type {(inputs: Pc_Cmp_Adv_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`与 Acrobat 订阅相比，每人每年节省 180 至 300 美元。`)
};

/**
* | output |
* | --- |
* | "Saves US$180 to US$300 per person per year compared with an Acrobat subscription." |
*
* @param {Pc_Cmp_Adv_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_adv_1 = /** @type {((inputs?: Pc_Cmp_Adv_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Adv_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_adv_1(inputs)
	return zh_pc_cmp_adv_1(inputs)
});
export { pc_cmp_adv_1 as "pc.cmp.adv.1" }